'use strict';

require("babel-polyfill");

const $ = require('jquery');
import '../scss/iframe.scss';

const DropIndicator = require('./rendering/DropIndicator');
const ChannelFactory = require('./rendering/ChannelFactory');
const CommandsBinder = require('./rendering/CommandsBinder');
const PageDomStateTracker = require('./rendering/PageDomStateTracker');
const EventPreventer = require('./rendering/EventPreventer');
const DomChanger = require('./rendering/DomChanger');
const PasteHandler = require('./rendering/PasteHandler');

/** @module iframe
 * @requires jquery
 * @requires DropIndicator
 * @requires ChannelFactory
 * @requires CommandsBinder
 * @requires PageDomStateTracker
 * @requires EventPreventer
 * @requires DomChanger
 */

window.addEventListener('DOMContentLoaded', () => {
	const root = document.createElement('div');
	document.body.appendChild(root);
	const channel = ChannelFactory.CreateChildChannel(window.parent, root);
	channel.setup();

	const commandsBinder = new CommandsBinder();
	commandsBinder.bind(root);

	const dropIndicator = new DropIndicator();
	dropIndicator.setup(root);

	const eventPreventer = new EventPreventer();
	eventPreventer.setup(root);

	const tracker = new PageDomStateTracker(root, (state) => {
		channel.proxy.handle({
			state: state
		});
	});
	tracker.setup();

	const domChanger = new DomChanger();
	domChanger.setup(root);

	const pasteHandler = new PasteHandler();
	pasteHandler.setup(root);
})


// IE11 doesn't trigger input events on contenteditable
// elements so we need to simulate that for saving changes in the editor
$('body').on('focus', '[contenteditable]', function() {
	var $this = $(this);
	$this.data('before', $this.html());
	return $this;
}).on('blur keyup paste input', '[contenteditable]', function() {
	var $this = $(this);
	if ($this.data('before') !== $this.html()) {
		$this.data('before', $this.html());
		$this.trigger('input');
	}
	return $this;
});
